export const getPortletGroups = () => {
    return [
        'renderOverallRating',
        'renderYourReviewAndRating',
        'renderReviewTitle',
        'renderReviewContent',
        'renderOtherRatings',
        'renderExperienceTypes',
        'renderMemberCategories',
        'renderFirstName',
        'renderLastName',
        'renderDisplayName',
        'renderContactDetails',
        'renderTelephone',
        'renderEmailAddress',
        'renderTermsAndCondition',
        'renderRecaptcha'
    ];
}

export const getPageMeta = () => {
    return {
        "WidgetIntroduction": "Sharing your insights and experiences can help others learn more about this member",
        "WidgetReviewTitle": "",
        "WidgetOverallRatingDescription": "",
        "WidgetCategoryOfCareDescription": "",
        "WidgetExperienceDescription": "",
        "WidgetDisplayNameDescription": "Please edit if you wish, but it is now our policy not to publish the last name of the reviewer.",
        "WidgetReviewAndRatingDescription": "",
        "WidgetReviewContentDescription": "Reviews comments must comply with our ${widget_terms_and_conditions_link} Reviewer Guidelines${widget_terms_and_conditions_link_end} Please do not use names (job titles / positions are acceptable) of any individual or identifying features, abusive remarks, or allegations of negligence or criminal activity. ",
        "WidgetContactDetailsDescription": "We respect your privacy. Your phone number and email will NOT be published with your review. By providing this information you allow us to verify your status with participating senior communities and senior referral services. We include special stamps on verified reviews.",
        "WidgetConfirmationMessage": "Thank you for submitting your review, you will be notified by email once the review has been verified and published."
    }
}

export const getAllBranding = (branding: string) => {

    console.log('Branding ' + branding);

    const themeData = branding === 'apfm' ? {
        "ThemeID": "apfm",
        "SiteName": "A Place For Mom",
        "Meta": {
            "GuidlinesLink": "https://www.aplaceformom.com/terms-of-use",
            "TermsAndConditionsLink": "https://www.aplaceformom.com/terms-of-use",
            "WidgetTermsAndConditionsLink": "https://support.aplaceformom.com/docs/review-policy",
            "WidgetGuidlinesLink": "https://www.aplaceformom.com/terms-of-use"
        } 
    }: {
        "ThemeID": "sa",
        "SiteName": "Senior Advisor",
        "Meta": {
            "GuidlinesLink": "https://www.aplaceformom.com/terms-of-use",
            "TermsAndConditionsLink": "https://www.aplaceformom.com/terms-of-use",
            "WidgetTermsAndConditionsLink": "https://support.aplaceformom.com/docs/review-policy",
            "WidgetGuidlinesLink": "https://www.aplaceformom.com/terms-of-use"
        }
    };

    const brandingData = branding === 'apfm' ? {
        "SiteName": "apfm",
        "Logo": "https://stagingapfmblob.blob.core.windows.net/widgetassets/apfm.png",
        "Website": "https://www.aplaceformom.com",
        "ParentSiteName": "apfm",
    } : {
        "SiteName": "sa",
        "Logo": "https://stagingapfmblob.blob.core.windows.net/widgetassets/sa.png",
        "Website": "https://www.senioradvisor.com",
        "ParentSiteName": "apfm",
    };

    return  { 
        themeData, 
        brandingData 
    };
}
